// extracted by mini-css-extract-plugin
export default {"image-credit":"image-credit--Zuq2B","imageCredit":"image-credit--Zuq2B","right":"right--VuQ73","left":"left--ev4RV"};